/* v29 (12/10, Xebec) : fiches Dentifrice, Siwak Addict, NanoBrosse et Recharge.
   L'abonnement est coché d'avance et se combine avec la quantité (1, 2 ou 3).
   Ce script ne calcule aucun prix : il recopie ceux écrits dans le balisage
   (data-total-price = achat unique, data-abo-total = abonnement), qui sont les
   prix exacts du panier Shopify (plan d'abonnement + remises « Abonnement … »).
   Les prix des cartes de formule et du bouton restent gérés par components--pdp-cart.js. */
(function () {
  'use strict';
  var zone = document.querySelector('[data-kx-formules]');
  if (!zone) return;

  var nom1 = zone.getAttribute('data-nom-1') || '';
  var nomN = zone.getAttribute('data-nom-n') || nom1;
  var portAbo = zone.getAttribute('data-port-abo') === 'offert';
  var cartes = [].slice.call(document.querySelectorAll('.pdp__flavour'));
  var cures = [].slice.call(document.querySelectorAll('.pdp__cure'));

  function choisie(liste) { return liste.filter(function (x) { return x.classList.contains('is-selected'); })[0] || liste[0] || null; }
  function enAbo() { var c = choisie(cures); return !!(c && c.getAttribute('data-subscription') === 'true'); }
  function texte(sel, val) { [].slice.call(zone.querySelectorAll(sel)).forEach(function (n) { n.textContent = val; }); }
  function cents(v) { var m = String(v || '').match(/\d+(?:,\d{2})?/); return m ? Math.round(parseFloat(m[0].replace(',', '.')) * 100) : 0; }
  function prix(c) { return (c / 100).toFixed(2).replace('.', ',').replace(/,00$/, '') + ' €'; }

  function maj() {
    var abo = enAbo();
    zone.classList.toggle('is-abo', abo);
    var carte = choisie(cartes);
    var n = carte ? (parseInt(carte.getAttribute('data-quantity'), 10) || 1) : 1;

    /* Cartes de quantité : prix de la formule choisie. En abonnement, le prix barré
       est celui du même lot en achat unique (la remise de 15 % porte dessus). */
    cartes.forEach(function (c) {
      var unique = c.getAttribute('data-total-price');
      var aboTotal = c.getAttribute('data-abo-total');
      var p = c.querySelector('.pdp__flavour-prix');
      var barre = c.querySelector('.pdp__flavour-jour');
      var eco = c.querySelector('.pdp__flavour-save');
      var port = c.querySelector('.pdp__flavour-port');
      var detail = c.querySelector('.pdp__flavour-detail');
      var modeAbo = abo && aboTotal;
      if (p) p.textContent = modeAbo ? aboTotal : unique;
      if (barre) {
        var b = modeAbo ? unique : c.getAttribute('data-barre-unique');
        barre.innerHTML = b ? '<s>' + b + '</s>' : '';
        barre.hidden = !b;
      }
      if (eco) {
        var e = modeAbo ? c.getAttribute('data-eco-abo') : c.getAttribute('data-eco-unique');
        eco.textContent = e || '';
        eco.hidden = !e;
      }
      if (port) port.hidden = !c.classList.contains('is-selected') || (abo ? !portAbo : !(cents(unique) >= 3000));
      /* v31 (13/10, Xebec) : prix par jour visible sur chaque carte (si la carte donne sa durée). */
      var cj = c.querySelector('.kx-carte-jour');
      var jc = parseInt(c.getAttribute('data-jours'), 10) || 0;
      if (cj) cj.textContent = jc ? prix(Math.round(cents(modeAbo ? aboTotal : unique) / jc)) + ' / jour' : '';
      if (detail) {
        var d = c.getAttribute(abo ? 'data-detail-abo' : 'data-detail-unique');
        if (d) detail.textContent = d;
      }
    });

    /* Textes de la carte abonnement : montants et quantité du lot choisi. */
    if (carte) {
      texte('[data-kx="abo"]', carte.getAttribute('data-abo-total') || '');
      texte('[data-kx="unique"]', carte.getAttribute('data-total-price') || '');
      texte('[data-kx="qte"]', n + ' ' + (n > 1 ? nomN : nom1));
      var aboC = cents(carte.getAttribute('data-abo-total'));
      var uniC = cents(carte.getAttribute('data-total-price'));
      texte('[data-kx="unite"]', aboC ? prix(Math.round(aboC / n)) : '');
      /* v31 : prix par jour et pourcentage réel d'économie du lot choisi. */
      var jours = parseInt(carte.getAttribute('data-jours'), 10) || 0;
      texte('[data-kx="jour-abo"]', (jours && aboC) ? prix(Math.round(aboC / jours)) : '');
      texte('[data-kx="jour-unique"]', (jours && uniC) ? prix(Math.round(uniC / jours)) : '');
      texte('[data-kx="pct"]', (aboC && uniC && uniC > aboC) ? '-' + Math.round((1 - aboC / uniC) * 100) + ' %' : '');
      var img = carte.querySelector('.pdp__flavour-img');
      if (img) [].slice.call(zone.querySelectorAll('[data-kx="img"]')).forEach(function (i) { if (i.getAttribute('src') !== img.getAttribute('src')) i.setAttribute('src', img.getAttribute('src')); });
    }

    /* Aide sous les quantités et note sous le bouton : une version par formule. */
    [].slice.call(document.querySelectorAll('[data-texte-abo][data-texte-unique]')).forEach(function (el) {
      el.innerHTML = el.getAttribute(abo ? 'data-texte-abo' : 'data-texte-unique');
    });
  }

  cartes.concat(cures).forEach(function (b) { b.addEventListener('click', function () { maj(); }); });

  /* Rappel en bas de page : remonte au choix, abonnement coché. */
  [].slice.call(document.querySelectorAll('[data-kx-rappel]')).forEach(function (r) {
    r.addEventListener('click', function () {
      var d = document.querySelector('.pdp__cure[data-defaut]');
      if (d && !d.classList.contains('is-selected')) d.click();
    });
  });

  maj();
})();
